import modal from './modal.vue';

const ModalComponent = {
  install:(Vue) => {
    const modelConstructor = Vue.extend(modal);
    const instance = new modelConstructor();
    instance.$mount();
    document.body.appendChild(instance.$el);

    Vue.prototype.$modal = {
      show: function(e) {
        let option = Object.assign(
          {
            title: '',
            btn: '',
            btnGroup: [],
            content: '',
            contentStyle: '',
            containerStyle: '',
            closeIcon: false,
            maskClick: false,
            onClick: () => {},
            buttonClick: () => {}
          },
          e
        );
        Object.keys(option).forEach(key=> {
          instance[key] = option[key];
        });
        if(option.title || option.content) {
          instance.visible =  true;
        }
      },
      hide: function() {
        instance.visible =  false;
      }
    }
  }
};

export default ModalComponent;